export const getRootDomain = () =>
  window.PF.config.ms_teams_domain || window.PF.config.development_domain || window.location.hostname;
